export default __webpack_public_path__ + "static/media/newsDetailsImg1.ee0a7086.webp";